export default "__VITE_ASSET__BnQyY7LN__"